function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInductive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 92,
    viewBox: "0 0 80 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1595"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1591"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Polygon 8",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40 0 40 52H0z",
    style: {
      stroke: "none"
    },
    transform: "rotate(180 40 36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 3.28 4.062 50h71.876L40 3.28M40 0l40 52H0L40 0z",
    style: {
      fill: "#7EEAFF",
      stroke: "none"
    },
    transform: "rotate(180 40 36)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 3633",
    transform: "translate(33 77)",
    style: {
      stroke: "#7EEAFF",
      strokeWidth: 2,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 3634",
    transform: "translate(65)",
    style: {
      stroke: "#7EEAFF",
      strokeWidth: 2,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 3635",
    transform: "translate(33)",
    style: {
      stroke: "#7EEAFF",
      strokeWidth: 2,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 3636",
    style: {
      stroke: "#7EEAFF",
      strokeWidth: 2,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.5,
    style: {
      fill: "none"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInductive);
export default __webpack_public_path__ + "static/media/inductive.3a7662147e8ec7342326fe7d1f4d8ecf.svg";
export { ForwardRef as ReactComponent };